import type { ButtonProps } from '../../../../../../app-v2/design-systems/components/inputs/button/type'
import type, { Element } from 'react'
import { colors } from 'shared/assets/styles'
import { BORDER, COLOR, SPACING } from '../../../../../../app-v2/design-tokens'
import { Button } from '../../../../../../app-v2/design-systems'
import React from 'react'
import styled from 'styled-components'
import { SmallText, Text } from '../../../../../common/typography'
import { Chevron } from '../../../../../assets/icons'
import { useIntl } from 'react-intl'

type Props = {
    icon: Element<any>,
    title: string,
    description: string
}

export const ButtonIcon = (props: ButtonProps & Props) => {
    const { title, description, icon, onClick, disabled } = props

    const intl = useIntl()

    return (
        <Button
            fullLength
            variant={'contained'}
            buttonColor={'transparent'}
            labelColor={COLOR.PRIMARY}
            onClick={onClick}
            otherStyle={{
                padding: SPACING.S,
                borderRadius: BORDER.RADIUS.S,
                backgroundColor: colors.white,
                display: 'flex',
                flexWrap: 'wrap',
                flex: 1
            }}
            diabled={disabled}
            {...props}>
            <StyledOrderTypeContainer>
                <StyledLeftContainer>
                    <StyledLeftIcon>{icon}</StyledLeftIcon>
                    <StyledTextsContainer>
                        <Text
                            color={!disabled ? COLOR.PRIMARY : colors.disabled}>
                            {title}
                        </Text>
                        <SmallText
                            color={!disabled ? COLOR.PRIMARY : colors.disabled}>
                            {description}
                        </SmallText>
                        {disabled && (
                            <SmallText color={colors.red}>
                                {intl.formatMessage({
                                    id: 'ecommerce.order.mode.choice.unvailable'
                                })}
                            </SmallText>
                        )}
                    </StyledTextsContainer>
                </StyledLeftContainer>
                <StyledRightIcon>
                    <Chevron
                        size={26}
                        color={!disabled ? COLOR.PRIMARY : colors.disabled}
                    />
                </StyledRightIcon>
            </StyledOrderTypeContainer>
        </Button>
    )
}

const StyledOrderTypeContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: ${SPACING.XS};
    align-items: center;
    width: 100%;
`

const StyledTextsContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: ${SPACING.XXXS};
    text-align: start;
`

const StyledLeftIcon = styled.div`
    display: flex;
    align-self: flex-start;
`

const StyledRightIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${SPACING.XXL};
    height: ${SPACING.XXL};
`

const StyledLeftContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    gap: ${SPACING.XS};
`
